import { Controller } from "@hotwired/stimulus"
import { useDebounce } from 'stimulus-use'

/**
 * This controller manages the search bar in the navbar.
 * The targets allow the NavbarSearchForm controller to target DOM elements for updates.
 * The actions allow communication with the NavbarSearchForm controller and focus the correct elements
 * in the modal based on the element targeted by the user in the navbar.
**/

export default class extends Controller {
  static targets = [
    "queryButton", "packageCategoryButton", "guestsButton", "bedroomsButton",
    "queryContainer", "packageCategoryDivider", "packageCategoryContainer", "guestsContainer", "guestDivider",
    "bedroomsContainer", "keywordsButton", "keywordsContainer", "locationTypeContainer", "locationTypeDivider",
    "subCategoryContainer", "subCategoryButton", "subCategoryDivider"
  ]
  static outlets = ["navbar-search-form"]
  static debounces = ["focusQueryInput", "focusPackageCategoryInput", "focusGuestsInput", "focusBedroomsInput", "focusKeywordsInput", "focusLocationTypeInput", "focusSubCategoryButton"];

  connect() {
    useDebounce(this, { wait: 500 })
  }

  focusQueryInput() {
    const target = this.navbarSearchFormOutlet.queryTarget
    target.focus()
    target.selectionStart = target.selectionEnd = target.value.length
  }

  focusPackageCategoryInput() {
    this.navbarSearchFormOutlet.packageCategoryInputTarget.focus()
  }

  focusLocationTypeInput() {
    this.navbarSearchFormOutlet.locationTypeInputTarget.focus()
  }

  focusSubCategoryButton() {
    this.navbarSearchFormOutlet.subCategoryInputTarget.focus()
  }

  focusGuestsInput() {
    this.navbarSearchFormOutlet.guestsInputTarget.focus()
  }

  focusBedroomsInput() {
    this.navbarSearchFormOutlet.bedroomsInputTarget.focus()
  }

  focusKeywordsInput() {
    this.navbarSearchFormOutlet.keywordsInputTarget.focus()
    this.navbarSearchFormOutlet.keywordsInputTarget.selectionStart = this.navbarSearchFormOutlet.keywordsInputTarget.selectionEnd = this.navbarSearchFormOutlet.keywordsInputTarget.value.length
  }
}
